import { render, staticRenderFns } from "./high_stock_age_code_list.vue?vue&type=template&id=ec4c2d84"
import script from "./high_stock_age_code_list.vue?vue&type=script&lang=js"
export * from "./high_stock_age_code_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports